// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1xtdr","left":"InfoRow_left__1reUp"};